import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { MdClose } from 'react-icons/md';
import { AiOutlineDelete } from "react-icons/ai";
import Loader from "react-loader-spinner";
import * as jobActions from '../../Redux/Actions/jobs';
import DropDown from '../Ui/DropDown';
import Upload from '../Ui/Upload';
import { toastMessage } from '../../utils/toast';
import { resetFileName } from '../../utils/resetFileName';

const ReferenceModal = ({ t, showModal, receiptData, receiptOptions, referenceEditData, loading, jobId, handleOk, handleCancel, footerOption1, footerOption2 }) => {

    const [selectType, setSelectType] = useState();
    const [amount, setAmount] = useState('');
    const [referenceNumber, setReferenceNumber] = useState('');
    const [paymentReceipt, setPaymentReceipt] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [paymentReceiptID, setPaymentReceiptID] = useState('');
    const referenceData = useSelector(({Job}) => Job.referenceData);
    const [errMsg, setErrMsg] = useState('');
    const dispatch = useDispatch();

    useEffect(() => {
        setSelectType();
        setAmount('');
        setReferenceNumber('');
        setPaymentReceipt('');
        setPaymentReceiptID('');
        setErrMsg('');
    }, []);

    useEffect(() => {
        let filteredType = receiptOptions.filter(({label}) => label === referenceEditData.key);
        setSelectType(filteredType[0]);
        setAmount(referenceEditData.payableAmount);
        setPaymentReceipt(referenceEditData.value);
        setReferenceNumber(referenceEditData.receiptNumber);
        setPaymentReceiptID(referenceEditData.value);
        setErrMsg('');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [referenceEditData]);

    useEffect(() => {
        dispatch(jobActions.jobReferenceData([]));
    }, [dispatch]);

    const handleSelectType = (type) => {
        setSelectType(type);
        let receipt = receiptData.filter(({name}) => name === type.value)[0];
        setAmount(receipt.amount);
    };

    const handleAddReference = (e) => {
        let parsedAmount = parseFloat(amount)
        let receipt = receiptData.filter(({name}) => name === selectType.value)[0];
        if ((parsedAmount >= 0)) {
            let data = { "type": "file", "key": selectType.label, moduleType: receipt.moduleType, id: receipt.id ,moduleGroupId: receipt.moduleGroupId, value: paymentReceiptID, receiptNumber: referenceNumber, payableAmount: parsedAmount, status: 'Open' };
            setPaymentReceipt(''); setAmount(''); setReferenceNumber(''); setPaymentReceiptID(''); setSelectType([]); setErrMsg('');
            dispatch(jobActions.addJobReference(data));
        } else {
            setErrMsg(`Please enter valid amount`);
        } 
    };

    const handleUploadPaymentReceipt = (files) => {
        if(!files) {
            return;
        }
        
        setButtonLoading(true);
        let data = new FormData();
        setPaymentReceipt(files);
        data.append('jobId', jobId);
        data.append('file', resetFileName(files));
        let woExtensionName = files && files.name.toLowerCase().split('.');
        data.append('extension', '.' + woExtensionName[woExtensionName.length - 1]);

        jobActions.uploadPaymentReceipt(data).then(res => {
            if(res && res.data){
                setButtonLoading(false);
                setPaymentReceiptID(res.data);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to upload the document`);
        });
    };

    return(
        <div>
            <div className="modal" style={{display: (showModal ? 'block': '')}}>
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{(Object.keys(referenceEditData).length !== 0) ? t("jobsManagement.infoJob.createReference.updateTitle") : t("jobsManagement.infoJob.createReference.addTitle")}</h5>
                            <button type="button" className="close" aria-label="Close" onClick={handleCancel} style={{border: 'none'}}>
                                <MdClose />
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex flex-column mb-3">
                                <label className="form-label mb-1">{t("jobsManagement.infoJob.createReference.type")}</label>
                                <DropDown value={selectType} placeholder={t("jobsManagement.infoJob.createReference.typePlaceholder")} options={receiptOptions} onChange={e => handleSelectType(e)} />
                            </div>
                            {(selectType && selectType.value) && <div>
                                {(referenceEditData && referenceEditData.fileName) 
                                ?   <div className="d-flex flex-column mb-3">
                                        <label className="form-label mb-1">{t("jobsManagement.infoJob.createReference.paymentReceipt")}</label>
                                        {(paymentReceiptID && referenceEditData.thumbnailUri) && <img alt="Document Preview" src={referenceEditData.thumbnailUri} style={{ width: '25%', height: 'auto', margin: '0 0 5px 0' }} />}
                                        <div className="d-flex align-items-center">
                                            <Upload documentName={paymentReceiptID && referenceEditData.fileName} onChange={e => handleUploadPaymentReceipt(e.target.files[0])} />
                                            {paymentReceiptID && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => setPaymentReceiptID('')} />}
                                        </div>
                                    </div> 
                                : <div className="d-flex flex-column mb-3">
                                        <label className="form-label mb-1">{t("jobsManagement.infoJob.createReference.paymentReceipt")}</label>
                                        {paymentReceipt && paymentReceipt.type && paymentReceipt.type.includes('image') && <img alt="Document Preview" src={URL.createObjectURL(paymentReceipt)} style={{ width: '25%', height: 'auto', margin: '0 0 5px 0' }} />}
                                        <div className="d-flex align-items-center">
                                            <Upload documentName={paymentReceipt && paymentReceipt.name} onChange={e => handleUploadPaymentReceipt(e.target.files[0])} />
                                            {paymentReceipt && <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => {setPaymentReceipt(''); setPaymentReceiptID('');}} />}
                                        </div>
                                    </div>}
                                <div className="d-flex flex-column mb-3">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.createReference.referenceNumber")}</label>
                                    <input placeholder={t("jobsManagement.infoJob.createReference.referenceNumberPlaceholder")} type="text" className="form-control"
                                        name="referenceNumber" value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} />
                                </div>
                                <div className="d-flex flex-column mb-1">
                                    <label className="form-label mb-1">{t("jobsManagement.infoJob.createReference.amount")}</label>
                                    <input placeholder={t("jobsManagement.infoJob.createReference.amountPlaceholder")} type="number" className="form-control"
                                        name="amount" value={amount} onChange={e => {setAmount(e.target.value); setErrMsg('')}} />
                                </div>
                                {(errMsg !== '') && <p className="text-danger my-2 text-center font-weight-bold">{errMsg}</p>}
                                <button type="button"
                                    disabled={(referenceNumber === undefined) || buttonLoading} className="btn btn-primary font-weight-bold d-flex align-items-center" style={{margin: 'auto'}} onClick={handleAddReference}>
                                    {t("jobsManagement.infoJob.createReference.add")}{buttonLoading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                                </button>
                            </div>}
                            <div className="d-flex flex-column mt-3 mb-1">
                                <p className="text-muted mb-2">{t("jobsManagement.infoJob.createReference.jobReference")}</p>
                                {(referenceData.length === 0) ? <p className="text-muted text-center">{t("jobsManagement.noDataAvailable")}</p> : 
                                    referenceData.map(({key, value, receiptNumber, payableAmount, status}, index) => 
                                        <div key={index} className="d-flex align-items-start mb-1">
                                            <p className="me-2">{index+1}.</p>
                                            <div>
                                                <p>{t("jobsManagement.infoJob.createReference.receiptName")} - {key}</p>
                                                {receiptNumber && <p>{t("jobsManagement.infoJob.createReference.refNo")}: {receiptNumber}</p>}
                                                {payableAmount && <p>{t("jobsManagement.infoJob.createReference.amount")}: {payableAmount}</p>}
                                            </div>
                                            <AiOutlineDelete className="c-pointer ms-1" style={{fontSize: '18px'}} onClick={() => dispatch(jobActions.removeJobReference(index))} />
                                        </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-light-danger font-weight-bold" disabled={loading} onClick={handleCancel}>{footerOption2 ? footerOption2 : t("jobsManagement.infoJob.createReference.close")}</button>
                            <button type="button" className="btn btn-primary font-weight-bold d-flex align-items-center" disabled={loading || (referenceData.length === 0)} onClick={() => handleOk(referenceData)}>{footerOption1 ? footerOption1 : t("jobsManagement.infoJob.createReference.ok")}
                                {loading && <Loader type="Oval" color="#fff" height={20} width={20} style={{marginLeft: '10px'}} />}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop show"></div>
        </div>
    );
};

export default ReferenceModal;